import { Checkbox } from "@material-ui/core";
import { translate } from "../../../../translations/index.ts";

import styles from "../createGame.module.css";

export default function SettingsStep({ template, setTemplate }) {
  const selectSetting = (event, setting) => {
    setTemplate({ ...template, [setting]: event.target.checked });
  };

  const availableSettings = ["skipQuestions", "ownArguments", "ownTempo"];

  return (
    <section>
      <div>
        <h3 className={styles.stepTitle}>
          {translate("teacher.gameSettings.steps.options.title")}
        </h3>
        <div>
          {availableSettings.map((setting) => (
            <div className={styles.settingWrapper} key={setting}>
              <div className={styles.gameSettingContainer}>
                <Checkbox
                  value={setting}
                  id={`setting-${setting}`}
                  checked={template[setting]}
                  onChange={(e) => selectSetting(e, setting)}
                />
                <label
                  htmlFor={`setting-${setting}`}
                  className={styles.settingTitle}
                >
                  {translate([
                    "teacher",
                    "gameSettings",
                    "steps",
                    "options",
                    setting,
                    "label",
                  ])}
                </label>
              </div>
              <p className={styles.settingDescription}>
                {translate([
                  "teacher",
                  "gameSettings",
                  "steps",
                  "options",
                  setting,
                  "description",
                ])}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
